<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$( window ).on('load', function() {
    setTimeout(() => {
        var spans = $('.menu-heading-mobile span');
        $(spans).each(function(index, element) {
            $(element).toggleClass('is-active');
        });
        $('.site-nav-mobile .header__inline-menu').toggleClass('is-active');
    }, 1000);


    let lastScrollTop = 0;
    let scrollDirection = 'down'; // initial direction

    function trackTabsPosition() {
        const scrollTop = $(window).scrollTop();
        
        // Determine scroll direction
        if (scrollTop > lastScrollTop) {
            scrollDirection = 'down';
        } else if (scrollTop < lastScrollTop) {
            scrollDirection = 'up';
        }
        // If scrollTop === lastScrollTop, direction remains unchanged
        
        lastScrollTop = scrollTop;
        
        $('.product-tabs-content').each(function() {
            const $tabs_container = $(this);
            const rect = this.getBoundingClientRect();
            
            // Get position relative to viewport
            const distanceFromTop = rect.top;
            const distanceFromBottom = rect.bottom;
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
            
            // Add data attributes for tracking
            // $tabs_container.attr('data-from-top', Math.round(distanceFromTop));
            // $tabs_container.attr('data-from-bottom', Math.round(distanceFromBottom));
            // $tabs_container.attr('data-visible', isVisible);
            // $tabs_container.attr('data-scroll-direction', scrollDirection);
            
            // Add classes based on position
            $tabs_container.toggleClass('near-top', distanceFromTop < 100);
            $tabs_container.toggleClass('at-top', distanceFromTop <= 0);
            $tabs_container.toggleClass('in-viewport', isVisible);
            
            // Log scroll direction change (optional - can be removed if too verbose)
            // console.log('Scroll direction:', scrollDirection, '| Scroll position:', scrollTop);
            
            if (isVisible && Math.round(distanceFromBottom) > 100) {
                if (Math.round(distanceFromTop) < 50) {
                    $tabs_container.addClass('pt-50');
                    $tabs_container.siblings('ul.list-product-tabs').addClass('tabs-stick-to-top');
                    if (scrollDirection == 'up') {
                        $tabs_container.siblings('ul.list-product-tabs').addClass('top-50');
                        $tabs_container.siblings('ul.list-product-tabs').removeClass('top-0');
                    } else {
                        $tabs_container.siblings('ul.list-product-tabs').removeClass('top-50');
                        $tabs_container.siblings('ul.list-product-tabs').addClass('top-0');
                    }
                    // console.log('Added sticky class - Scrolling:', scrollDirection);
                } else {
                    if (Math.round(distanceFromTop) > 50) {
                        $tabs_container.removeClass('pt-50');
                    }
                    $tabs_container.siblings('ul.list-product-tabs').removeClass('tabs-stick-to-top');
                }
            } else {
                $tabs_container.removeClass('pt-50');
                $tabs_container.siblings('ul.list-product-tabs').removeClass('tabs-stick-to-top');
            }
        });
    }

    // Throttled scroll event
    let ticking = false;
    let lastLoggedDirection = '';

    $(window).on('scroll resize', function() {
        if (!ticking) {
            requestAnimationFrame(function() {
                const currentDirection = scrollDirection;
                trackTabsPosition();
                
                // Log only when direction changes
                if (currentDirection !== lastLoggedDirection) {
                    // console.log('Scroll direction changed to:', currentDirection);
                    lastLoggedDirection = currentDirection;
                }
                
                ticking = false;
            });
            ticking = true;
        }
    });

    trackTabsPosition(); // Initial call

});

